module.exports = __webpack_public_path__ + "img/icon_building.494cdfa.png";